 <template>
<div>
  <box-score v-bind:gameId=this.$route.params.gameId></box-score>
  <div class="tile is-parent is-12 is-vertical">
    <article class="tile is-child box">
      <div class="container is-child" style="margin-top:5px;">
        <h2 class="subtitle">Quicklinks</h2>
        <button class="button is-large"  style="margin-top:5px;" v-scroll-to="'#PIMS'">PIMS</button>
        <button class="button is-large"  style="margin-top:5px;" v-scroll-to="'#TOI'">TOI</button>
        <button class="button is-large"  style="margin-top:5px;" v-scroll-to="'#Faceoffs'">Faceoffs</button>
        <button class="button is-large"  style="margin-top:5px;" v-scroll-to="'#Turnovers'">Turnovers</button>
        <button class="button is-large"  style="margin-top:5px;" v-scroll-to="'#Shots'">Shots</button>
        <button class="button is-large"  style="margin-top:5px;" v-scroll-to="'#Hits'">Hits</button>
      </div>
    </article>
  </div>
  <div class="title is-parent is-12 is-vertical">
    <article class="title is-child box">
      <div class="container is-child">
        <h2 class="subtitle">Use these stats in Season Totals?</h2>
        <button class="button is-large"  v-bind:class="{'unverified': this.Fixture.is_validated == 0,  'verified': this.Fixture.is_validated != 0}" @click="validateGame" >Validate Game</button>
      </div>
    </article>
  </div>
  <edit-roster v-bind:game_id=this.$route.params.gameId v-bind:team_name=this.Fixture.home_team.name v-bind:team_logo=this.Fixture.home_team.logo  v-bind:team_id=this.Fixture.home_team.id></edit-roster>
  <edit-roster v-bind:game_id=this.$route.params.gameId v-bind:team_name=this.Fixture.away_team.name  v-bind:team_logo=this.Fixture.away_team.logo v-bind:team_id=this.Fixture.away_team.id></edit-roster>
  <edit-item type="Goal" v-bind:open="editGoal">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="editGoalData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class=""  v-model="editGoalData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="goal_scorer">Goal Scorer</label>
          <div class="control">
            <div class="select is-small">
              <select  id="goal_scorer" name="goal_scorer" class="" v-model="editGoalData.goal_scorer" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="first_assist">First Assist</label>
          <div class="control">
            <div class="select is-small">
              <select id="first_assist" name="first_assist" class="" v-model="editGoalData.first_assist" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="second_assist">Second Assist</label>
          <div class="control">
            <div class="select is-small">
              <select id="second_assist" name="second_assist" class="" v-model="editGoalData.second_assist" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="on_ice_1">P1</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_1" name="on_ice_1" class="" v-model="editGoalData.on_ice_1" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_2">P2</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_2" name="on_ice_2" class="" v-model="editGoalData.on_ice_2" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_3">P3</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_3" name="on_ice_3" class="" v-model="editGoalData.on_ice_3" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_4">P4</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_4" name="on_ice_4" class="" v-model="editGoalData.on_ice_4" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_5">P5</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_5" name="on_ice_5" class="" v-model="editGoalData.on_ice_5" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_6">P6</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_6" name="on_ice_6" class="" v-model="editGoalData.on_ice_6" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button is-medium is-success" @click="submitEditGoal">Submit</button>
    <button class="button is-medium is-default" @click="cancelEdit">Cancel</button>
  </edit-item>
  <new-item type="Goal" v-bind:open="newGoal"  v-on:cancel="cancelNew">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="newGoalData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class=""  v-model="newGoalData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="goal_scorer">Goal Scorer</label>
          <div class="control">
            <div class="select is-small">
              <select  id="goal_scorer" name="goal_scorer" class="" v-model="newGoalData.goal_scorer" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="first_assist">First Assist</label>
          <div class="control">
            <div class="select is-small">
              <select id="first_assist" name="first_assist" class="" v-model="newGoalData.first_assist" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="second_assist">Second Assist</label>
          <div class="control">
            <div class="select is-small">
              <select id="second_assist" name="second_assist" class="" v-model="newGoalData.second_assist" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="on_ice_1">P1</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_1" name="on_ice_1" class="" v-model="newGoalData.on_ice_1" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_2">P2</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_2" name="on_ice_2" class="" v-model="newGoalData.on_ice_2" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_3">P3</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_3" name="on_ice_3" class="" v-model="newGoalData.on_ice_3" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_4">P4</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_4" name="on_ice_4" class="" v-model="newGoalData.on_ice_4" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_5">P5</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_5" name="on_ice_5" class="" v-model="newGoalData.on_ice_5" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="on_ice_6">P6</label>
          <div class="control">
            <div class="select is-small">
              <select id="on_ice_6" name="on_ice_6" class="" v-model="newGoalData.on_ice_6" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button is-medium is-success" @click="submitNewGoal">Submit</button>
    <button class="button is-medium is-default" @click="cancelNew">Cancel</button>
  </new-item>
<div class="is-parent is-12 is-vertical">
    <article class="tile is-child box">
      <div class="container is-child" style="margin-top:5px;">
        <h1 class="title has-text-centered">Official Goals</h1>
        <div class="table__wrapper">
          <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
              <thead>
                <th>Period</th>
                <th>Team</th>
                <th>Current Score</th>
                <th>Time</th>
                <th>Situation</th>
                <th>GS</th>
                <th>FA</th>
                <th>SA</th>
                <th>Player 1 +</th>
                <th>Player 2 +</th>
                <th>Player 3 +</th>
                <th>Player 4 +</th>
                <th>Player 5 +</th>
                <th>Player 6 +</th>
                <th>Player 1 -</th>
                <th>Player 2 -</th>
                <th>Player 3 -</th>
                <th>Player 4 -</th>
                <th>Player 5 -</th>
                <th>Player 6 -</th>
                <th></th>
              </thead>
              <tbody
              v-for="period_one in eihlInfo['1']" :key="period_one.time * Math.random()">
              <tr v-if="period_one.type === 'goal'">
                <td>1</td>
                <td>{{period_one.data.team}}</td>
                <td>{{period_one.data.currentScore }}</td>
                <td>{{Math.floor(period_one.data.scoreboardTime / 60) }}:{{period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60}}</td>
                <td>{{period_one.data.balance}}</td>
                <td v-if="period_one.data.scorer.jersey != null">{{period_one.data.scorer.jersey}}</td>
                <td v-if="period_one.data.assistants[0] != null">{{period_one.data.assistants[0].jersey}}</td><td v-else>-</td>
                <td v-if="period_one.data.assistants[1] != null">{{period_one.data.assistants[1].jersey}}</td><td v-else>CHECK!</td>
                <td v-if="period_one.data.attendants.positive[0] !=null">{{period_one.data.attendants.positive[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[1] !=null">{{period_one.data.attendants.positive[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[2] !=null">{{period_one.data.attendants.positive[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[3] !=null">{{period_one.data.attendants.positive[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[4] !=null">{{period_one.data.attendants.positive[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[5] !=null">{{period_one.data.attendants.positive[5].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[0] !=null">{{period_one.data.attendants.negative[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[1] !=null">{{period_one.data.attendants.negative[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[2] !=null">{{period_one.data.attendants.negative[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[3] !=null">{{period_one.data.attendants.negative[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[4] !=null">{{period_one.data.attendants.negative[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[5] !=null">{{period_one.data.attendants.negative[5].jersey}}</td> <td v-else>0</td>
              </tr>
              </tbody>
              <tbody
              v-for="period_one in eihlInfo['2']" :key="period_one">
              <tr v-if="period_one.type === 'goal'">
                <td>2</td>
                <td>{{period_one.data.team}}</td>
                <td>{{period_one.data.currentScore}}</td>
                <td>{{Math.floor(period_one.data.scoreboardTime / 60) }}:{{period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60}}</td>
                <td>{{period_one.data.balance}}</td>
                <td v-if="period_one.data.scorer.jersey != null">{{period_one.data.scorer.jersey}}</td>
                <td v-if="period_one.data.assistants[0] !=null">{{period_one.data.assistants[0].jersey}}</td><td v-else>-</td>
                <td v-if="period_one.data.assistants[1] !=null">{{period_one.data.assistants[1].jersey}}</td><td v-else>CHECK!</td>
                <td v-if="period_one.data.attendants.positive[0] !=null">{{period_one.data.attendants.positive[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[1] !=null">{{period_one.data.attendants.positive[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[2] !=null">{{period_one.data.attendants.positive[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[3] !=null">{{period_one.data.attendants.positive[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[4] !=null">{{period_one.data.attendants.positive[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[5] !=null">{{period_one.data.attendants.positive[5].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[0] !=null">{{period_one.data.attendants.negative[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[1] !=null">{{period_one.data.attendants.negative[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[2] !=null">{{period_one.data.attendants.negative[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[3] !=null">{{period_one.data.attendants.negative[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[4] !=null">{{period_one.data.attendants.negative[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[5] !=null">{{period_one.data.attendants.negative[5].jersey}}</td> <td v-else>0</td>
              </tr>
              </tbody>
              <tbody
              v-for="period_one in eihlInfo['3']" :key="period_one">
              <tr v-if="period_one.type === 'goal'">
                <td>3</td>
                <td>{{period_one.data.team}}</td>
                <td>{{period_one.data.currentScore}}</td>
                <td>{{Math.floor(period_one.data.scoreboardTime / 60) }}:{{period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60}}</td>
                <td>{{period_one.data.balance}}</td>
                <td v-if="period_one.data.scorer.jersey != null">{{period_one.data.scorer.jersey}}</td>
                <td v-if="period_one.data.assistants[0] !=null">{{period_one.data.assistants[0].jersey}}</td><td v-else>-</td>
                <td v-if="period_one.data.assistants[1] !=null">{{period_one.data.assistants[1].jersey}}</td><td v-else>CHECK!</td>
                <td v-if="period_one.data.attendants.positive[0] !=null">{{period_one.data.attendants.positive[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[1] !=null">{{period_one.data.attendants.positive[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[2] !=null">{{period_one.data.attendants.positive[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[3] !=null">{{period_one.data.attendants.positive[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[4] !=null">{{period_one.data.attendants.positive[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[5] !=null">{{period_one.data.attendants.positive[5].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[0] !=null">{{period_one.data.attendants.negative[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[1] !=null">{{period_one.data.attendants.negative[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[2] !=null">{{period_one.data.attendants.negative[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[3] !=null">{{period_one.data.attendants.negative[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[4] !=null">{{period_one.data.attendants.negative[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[5] !=null">{{period_one.data.attendants.negative[5].jersey}}</td> <td v-else>0</td>
              </tr>
              </tbody>
              <tbody
              v-for="period_one in eihlInfo['overtime']" :key="period_one">
              <tr v-if="period_one.type === 'goal'">
                <td>OT</td>
                <td>{{period_one.data.team}}</td>
                <td>{{period_one.data.currentScore}}</td>
                <td>{{Math.floor(period_one.data.scoreboardTime / 60) }}:{{period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60}}</td>
                <td>{{period_one.data.balance}}</td>
                <td v-if="period_one.data.scorer.jersey != null">{{period_one.data.scorer.jersey}}</td>
                <td v-if="period_one.data.assistants[0] !=null">{{period_one.data.assistants[0].jersey}}</td><td v-else>-</td>
                <td v-if="period_one.data.assistants[1] !=null">{{period_one.data.assistants[1].jersey}}</td><td v-else>CHECK!</td>
                <td v-if="period_one.data.attendants.positive[0] !=null">{{period_one.data.attendants.positive[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[1] !=null">{{period_one.data.attendants.positive[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[2] !=null">{{period_one.data.attendants.positive[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[3] !=null">{{period_one.data.attendants.positive[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[4] !=null">{{period_one.data.attendants.positive[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[5] !=null">{{period_one.data.attendants.positive[5].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[0] !=null">{{period_one.data.attendants.negative[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[1] !=null">{{period_one.data.attendants.negative[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[2] !=null">{{period_one.data.attendants.negative[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[3] !=null">{{period_one.data.attendants.negative[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[4] !=null">{{period_one.data.attendants.negative[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[5] !=null">{{period_one.data.attendants.negative[5].jersey}}</td> <td v-else>0</td>
              </tr>
              </tbody>
              <tbody
              v-for="period_one in eihlInfo['shootout']" :key="period_one">
              <tr v-if="period_one.type === 'goal'">
                <td>SO</td>
                <td>{{period_one.data.team}}</td>
                <td>{{period_one.data.currentScore}}</td>
                <td>{{Math.floor(period_one.data.scoreboardTime / 60) }}:{{period_one.data.scoreboardTime - Math.floor(period_one.data.scoreboardTime / 60) * 60}}</td>
                <td>{{period_one.data.balance}}</td>
                <td v-if="period_one.data.scorer.jersey != null">{{period_one.data.scorer.jersey}}</td>
                <td v-if="period_one.data.assistants[0] !=null">{{period_one.data.assistants[0].jersey}}</td><td v-else>-</td>
                <td v-if="period_one.data.assistants[1] !=null">{{period_one.data.assistants[1].jersey}}</td><td v-else>CHECK!</td>
                <td v-if="period_one.data.attendants.positive[0] !=null">{{period_one.data.attendants.positive[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[1] !=null">{{period_one.data.attendants.positive[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[2] !=null">{{period_one.data.attendants.positive[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[3] !=null">{{period_one.data.attendants.positive[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[4] !=null">{{period_one.data.attendants.positive[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.positive[5] !=null">{{period_one.data.attendants.positive[5].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[0] !=null">{{period_one.data.attendants.negative[0].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[1] !=null">{{period_one.data.attendants.negative[1].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[2] !=null">{{period_one.data.attendants.negative[2].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[3] !=null">{{period_one.data.attendants.negative[3].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[4] !=null">{{period_one.data.attendants.negative[4].jersey}}</td> <td v-else>0</td>
                <td v-if="period_one.data.attendants.negative[5] !=null">{{period_one.data.attendants.negative[5].jersey}}</td> <td v-else>0</td>
              </tr>
              </tbody>
            </table>
          </div>
      </div>
  </article>
</div>
  <edit-table id="Goals" heading="Goals" v-bind:headers="goalHeaders" v-bind:total="getTotalCountGoals" v-on:new="openNewGoal" v-on:edit="openEditGoal" v-on:reload="fetchRawGameData" v-bind:tableData="CleanGoals">
  </edit-table>
  <div class="is-parent is-12 is-vertical">
    <article class="tile is-child box">
      <div class="container is-child" style="margin-top:5px;">
        <h1 class="title has-text-centered">Official Penalties</h1>
        <div class="table__wrapper">
          <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
              <thead>
                <th>Period</th>
                <th>Team</th>
                <th>Time</th>
                <th>Duration</th>
                <th>Infraction</th>
                <th>Player</th>
              </thead>
              <tbody
              v-for="period_one in eihlInfo['1']" :key="period_one.time * Math.random()">
              <tr v-if="period_one.type === 'penalty'">
                <td>1</td>
                <td>{{period_one.data.team}}</td>
                <td>{{Math.floor(period_one.data.createTime / 60) }}:{{period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60}}</td>
                <td v-if="period_one.data.duration != null">{{period_one.data.duration / 60}}</td><td v-else>0</td>
                <td v-if="period_one.data.codename != null">{{period_one.data.codename}}</td><td v-else>0</td>
                <td v-if="period_one.data.disciplinedPlayer != null">{{period_one.data.disciplinedPlayer.jersey}}</td><td v-else>0</td>
              </tr>
              </tbody>
              <tbody
              v-for="period_one in eihlInfo['2']" :key="period_one.time * Math.random()">
              <tr v-if="period_one.type === 'penalty'">
                <td>2</td>
                <td>{{period_one.data.team}}</td>
                <td>{{Math.floor(period_one.data.createTime / 60) }}:{{period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60}}</td>
                <td v-if="period_one.data.duration != null">{{period_one.data.duration / 60}}</td><td v-else>0</td>
                <td v-if="period_one.data.codename != null">{{period_one.data.codename}}</td><td v-else>0</td>
                <td v-if="period_one.data.disciplinedPlayer != null">{{period_one.data.disciplinedPlayer.jersey}}</td><td v-else>0</td>
              </tr>
              </tbody>
              <tbody
              v-for="period_one in eihlInfo['3']" :key="period_one.time * Math.random()">
              <tr v-if="period_one.type === 'penalty'">
                <td>3</td>
                <td>{{period_one.data.team}}</td>
                <td>{{Math.floor(period_one.data.createTime / 60) }}:{{period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60}}</td> 
                <td v-if="period_one.data.duration != null">{{period_one.data.duration / 60}}</td><td v-else>0</td>
                <td v-if="period_one.data.codename != null">{{period_one.data.codename}}</td><td v-else>0</td>
                <td v-if="period_one.data.disciplinedPlayer != null">{{period_one.data.disciplinedPlayer.jersey}}</td><td v-else>0</td>
              </tr>
              </tbody>
              <tbody
              v-for="period_one in eihlInfo['3']" :key="period_one.time * Math.random()">
              <tr v-if="period_one.type === 'penalty'">
                <td>3</td>
                <td>{{period_one.data.team}}</td>
                <td>{{Math.floor(period_one.data.createTime / 60) }}:{{period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60}}</td> 
                <td v-if="period_one.data.duration != null">{{period_one.data.duration / 60}}</td><td v-else>0</td>
                <td v-if="period_one.data.codename != null">{{period_one.data.codename}}</td><td v-else>0</td>
                <td v-if="period_one.data.disciplinedPlayer != null">{{period_one.data.disciplinedPlayer.jersey}}</td><td v-else>0</td>
              </tr>
              </tbody>
              <tbody
              v-for="period_one in eihlInfo['overtime']" :key="period_one.time * Math.random()">
              <tr v-if="period_one.type === 'penalty'">
                <td>OT</td>
                <td>{{period_one.data.team}}</td>
                <td>{{Math.floor(period_one.data.createTime / 60) }}:{{period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60}}</td> 
                <td v-if="period_one.data.duration != null">{{period_one.data.duration / 60}}</td><td v-else>0</td>
                <td v-if="period_one.data.codename != null">{{period_one.data.codename}}</td><td v-else>0</td>
                <td v-if="period_one.data.disciplinedPlayer != null">{{period_one.data.disciplinedPlayer.jersey}}</td><td v-else>0</td>
              </tr>
              </tbody>
              <tbody
              v-for="period_one in eihlInfo['SO']" :key="period_one.time * Math.random()">
              <tr v-if="period_one.type === 'penalty'">
                <td>SO</td>
                <td>{{period_one.data.team}}</td>
                <td>{{Math.floor(period_one.data.createTime / 60) }}:{{period_one.data.createTime - Math.floor(period_one.data.createTime / 60) * 60}}</td> 
                <td v-if="period_one.data.duration != null">{{period_one.data.duration / 60}}</td><td v-else>0</td>
                <td v-if="period_one.data.codename != null">{{period_one.data.codename}}</td><td v-else>0</td>
                <td v-if="period_one.data.disciplinedPlayer != null">{{period_one.data.disciplinedPlayer.jersey}}</td><td v-else>0</td>
              </tr>
              </tbody>
            </table>
          </div>
      </div>
  </article>
</div>
  <new-item type="Penalty Minute" v-bind:open="newPenaltyMinute"  v-on:cancel="cancelNew">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="newPenaltyMinuteData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class=""  v-model="newPenaltyMinuteData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="taken_player">Taken Player</label>
          <div class="control">
            <div class="select is-small">
              <select  id="taken_player" name="taken_player" class="" v-model="newPenaltyMinuteData.taken_player" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="Drawn_player">Drawn Player</label>
          <div class="control">
            <div class="select is-small">
              <select id="Drawn_player" name="Drawn_player" class="" v-model="newPenaltyMinuteData.drawn_player" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="pen_for">Infraction</label>
          <div class="control">
            <div class="select is-small">
              <select id="pen_for" name="pen_for" class="" v-model="newPenaltyMinuteData.penalty_for" required>
                <option v-for="option in PenaltyOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="type">Type</label>
          <div class="control">
            <div class="select is-small">
              <select id="type" name="type" class="" v-model="newPenaltyMinuteData.penalty_type" required>
                <option>Minor</option>
                <option>Major</option>
                <option>Misconduct</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="type">Zone</label>
          <div class="control">
            <div class="select is-small">
              <select id="type" name="type" class="" v-model="newPenaltyMinuteData.penalty_zone" required>
                <option>Offensive</option>
                <option>Neutral</option>
                <option>Defensive</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="length">Length</label>
          <div class="control">
            <input    required   id="length"  class="input is-small"     v-model="newPenaltyMinuteData.penalty_length"   type="number"      name="length"   min="2" max="60">
          </div>
        </div>
      </div>

    </div>
    <button class="button is-medium is-success" @click="submitNewPenaltyMinute">Submit</button>
    <button class="button is-medium is-default" @click="cancelNew">Cancel</button>
  </new-item>
  <edit-item type="Penalty Minute" v-bind:open="editPenaltyMinute">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="editPenaltyMinuteData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class=""  v-model="editPenaltyMinuteData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="taken_player">Taken Player</label>
          <div class="control">
            <div class="select is-small">
              <select  id="taken_player" name="taken_player" class="" v-model="editPenaltyMinuteData.taken_player" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="Drawn_player">Drawn Player</label>
          <div class="control">
            <div class="select is-small">
              <select id="Drawn_player" name="Drawn_player" class="" v-model="editPenaltyMinuteData.drawn_player" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="pen_for">Infraction</label>
          <div class="control">
            <div class="select is-small">
              <select id="pen_for" name="pen_for" class="" v-model="editPenaltyMinuteData.penalty_for" required>
                <option v-for="option in PenaltyOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="type">Type</label>
          <div class="control">
            <div class="select is-small">
              <select id="type" name="type" class="" v-model="editPenaltyMinuteData.penalty_type" required>
                <option>Minor</option>
                <option>Major</option>
                <option>Misconduct</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="length">Length</label>
          <div class="control">
            <input    required   id="length"  class="input is-small"     v-model="editPenaltyMinuteData.penalty_length"   type="number"      name="length"   min="2" max="60">
          </div>
        </div>
        <div class="field">
          <label class="label" for="zone">Zone</label>
          <div class="control">
            <div class="select is-small">
              <select id="type" name="type" class="" v-model="editPenaltyMinuteData.penalty_zone" required>
                <option>Offensive</option>
                <option>Neutral</option>
                <option>Defensive</option>
              </select>
          </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button is-medium is-success" @click="submitEditPenaltyMinute">Submit</button>
    <button class="button is-medium is-default" @click="cancelEdit">Cancel</button>
  </edit-item>
  <edit-table id="PIMS" heading="Penalty Minutes" v-bind:headers="peanltyMinutesHeaders" v-bind:total="getTotalCountPenaltyMinutes" v-on:new="openNewPenaltyMinute" v-on:edit="openEditPenaltyMinutes" v-on:reload="fetchRawGameData" v-bind:tableData="CleanPenaltyMinutes">
  </edit-table>
  <new-item type="Faceoff" v-bind:open="newFaceoff"  v-on:cancel="cancelNew">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="newFaceoffData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class=""  v-model="newFaceoffData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="home_player">Home Player</label>
          <div class="control">
            <div class="select is-small">
              <select  id="home_player" name="home_player" class="" v-model="newFaceoffData.home_player" required>
                <option v-for="option in HomePlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="away_player">Away Player</label>
          <div class="control">
            <div class="select is-small">
              <select id="away_player" name="away_player" class="" v-model="newFaceoffData.away_player" required>
                <option v-for="option in AwayPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="lane">Lane</label>
          <div class="control">
            <div class="select is-small">
              <select id="lane" name="lane" class="" v-model="newFaceoffData.lane" required>
                <option>Left</option>
                <option>Center</option>
                <option>Right</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="zone">Zone</label>
          <div class="control">
            <div class="select is-small">
              <select id="zone" name="zone" class="" v-model="newFaceoffData.zone" required>
                <option>Offensive</option>
                <option>Neutral</option>
                <option>Defensive</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="result">Result</label>
          <div class="control">
            <div class="select is-small">
              <select id="result" name="result" class="" v-model="newFaceoffData.result" required>
                <option>WinWin</option>
                <option>WinLoss</option>
                <option>LossLoss</option>
                <option>LossWin</option>
              </select>
          </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button is-medium is-success" @click="submitNewFaceoff">Submit</button>
    <button class="button is-medium is-default" @click="cancelNew">Cancel</button>
  </new-item>
  <edit-item type="Faceoff" v-bind:open="editFaceoff">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="editFaceoffData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class=""  v-model="editFaceoffData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="home_player">Home Player</label>
          <div class="control">
            <div class="select is-small">
              <select  id="home_player" name="home_player" class="" v-model="editFaceoffData.home_player" required>
                <option v-for="option in HomePlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="away_player">Away Player</label>
          <div class="control">
            <div class="select is-small">
              <select id="away_player" name="away_player" class="" v-model="editFaceoffData.away_player" required>
                <option v-for="option in AwayPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="lane">Lane</label>
          <div class="control">
            <div class="select is-small">
              <select id="lane" name="lane" class="" v-model="editFaceoffData.lane" required>
                <option>Left</option>
                <option>Center</option>
                <option>Right</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="zone">Zone</label>
          <div class="control">
            <div class="select is-small">
              <select id="zone" name="zone" class="" v-model="editFaceoffData.zone" required>
                <option>Offensive</option>
                <option>Neutral</option>
                <option>Defensive</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="result">Result</label>
          <div class="control">
            <div class="select is-small">
              <select id="result" name="result" class="" v-model="editFaceoffData.result" required>
                <option>WinWin</option>
                <option>WinLoss</option>
                <option>LossLoss</option>
                <option>LossWin</option>
              </select>
          </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button is-medium is-success" @click="submitEditFaceoff">Submit</button>
    <button class="button is-medium is-default" @click="cancelEdit">Cancel</button>
  </edit-item>
  <edit-table id="Faceoffs" heading="Faceoffs" v-bind:headers="faceoffHeaders" v-bind:total="getTotalCountFaceoff" v-on:new="openNewFaceoff" v-on:edit="openEditFaceoff" v-on:reload="fetchRawGameData" v-bind:tableData="Test">
  </edit-table>
  <new-item type="Shot" v-bind:open="newShot" v-on:cancel="cancelNew">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p>
        <p class="label">Location 0,0,40 - Top Left</p>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="newShotData.period"   type="number"      name="period"   min="0" max="5">          </div>
          </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class="" v-model="newShotData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="player">Player</label>
          <div class="control">
            <div class="select is-small">
              <select id="player" name="player" class="" v-model="newShotData.player_id" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value" >{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label" for="result">Shot Type</label>
            <div class="control">
              <div class="select is-small">
                <select id="result" name="result" class="" v-model="newShotData.shot_type" required>
                  <option>OnNet</option>
                  <option>MissedNet</option>
                  <option>Blocked</option>
                  <option>Goal</option>
                </select>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button is-medium is-success" @click="submitNewShot">Submit</button>
    <button class="button is-medium is-default" @click="cancelNew">Cancel</button>
  </new-item>
  <edit-item type="Shot" v-bind:open="editShot">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="editShotData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class=""  v-model="editShotData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="player_id">Player</label>
          <div class="control">
            <div class="select is-small">
              <select  id="player_id" name="player_id" class="" v-model="editShotData.player_id" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
        <div class="field">
          <label class="label" for="result">Shot Type</label>
          <div class="control">
            <div class="select is-small">
              <select id="result" name="result" class="" v-model="editShotData.shot_type" required>
                <option>OnNet</option>
                <option>Blocked</option>
                <option>MissedNet</option>
                <option>Goal</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      
    </div>
    <button class="button is-medium is-success" @click="submitEditShot">Submit</button>
    <button class="button is-medium is-default" @click="cancelEdit">Cancel</button>
  </edit-item>
  <edit-table id="Shots" heading="Shots" v-bind:headers="shotHeaders"  v-bind:total="getTotalCountShots" v-on:new="openNewShot"  v-on:edit="openEditShot" v-bind:tableData="CleanShots" v-on:reload="fetchRawGameData">
  </edit-table>
  <new-item type="Hit" v-bind:open="newHit" v-on:cancel="cancelNew">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="newHitData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class="" v-model="newHitData.situation_id">
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="player">Player</label>
          <div class="control">
            <div class="select is-small">
              <select id="player" name="player" class="" v-model="newHitData.home_player">
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button is-medium is-success" @click="submitNewHit">Submit</button>
    <button class="button is-medium is-default" @click="cancelNew">Cancel</button>
  </new-item>
  <edit-item type="Hit" v-bind:open="editHit">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="editHitData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class=""  v-model="editHitData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="player_id">Player</label>
          <div class="control">
            <div class="select is-small">
              <select  id="player_id" name="player_id" class="" v-model="editHitData.home_player" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      
    </div>
    <button class="button is-medium is-success" @click="submitEditHit">Submit</button>
    <button class="button is-medium is-default" @click="cancelEdit">Cancel</button>
  </edit-item>
  <edit-table id="Hits" heading="Hits" v-bind:headers="hitHeaders"  v-bind:total="getTotalCountHits" v-on:new="openNewHit"  v-on:edit="openEditHit" v-bind:tableData="CleanHits" v-on:reload="fetchRawGameData">
  </edit-table>
  <new-item type="Turnover" v-bind:open="newTurnover" v-on:cancel="cancelNew">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="newTurnoverData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small">
              <select id="situation" name="situation" class="" v-model="newTurnoverData.situation_id">
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="home_player">Player</label>
          <div class="control">
            <div class="select is-small">
              <select id="home_player" name="home_player" class="" v-model="newTurnoverData.player_id">
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="zone">Zone</label>
          <div class="control">
            <div class="select is-small">
              <select id="zone" name="zone" class="" v-model="newTurnoverData.zone">
                <option>Offensive</option>
                <option>Neutral</option>
                <option>Defensive</option>
              </select>
          </div>
          </div>
        </div>
      </div>
    </div>
    <button class="button is-medium is-success" @click="submitNewTurnover">Submit</button>
    <button class="button is-medium is-default" @click="cancelNew">Cancel</button>
  </new-item>
  <edit-item type="Turnover" v-bind:open="editTurnover">
    <div class="columns table__wrapper">
      <div class="column">
        <p class="label">Game ID {{this.$route.params.gameId}}</p>
        <p class="label">Time 00:00:00</p> <br />
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="Period">Period</label>
          <div class="control">
            <input    required   id="period"  class="input is-small"     v-model="editTurnoverData.period"   type="number"      name="period"   min="0" max="5">
          </div>
        </div>
        <div class="field">
          <label class="label" for="situation">Situation</label>
          <div class="control">
            <div class="select is-small is-small">
              <select id="situation" name="situation" class=""  v-model="editTurnoverData.situation_id" required>
                <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label" for="player_id">Player</label>
          <div class="control">
            <div class="select is-small">
              <select  id="player_id" name="player_id" class="" v-model="editTurnoverData.player_id" required>
                <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
              </select>
          </div>
          </div>
        </div>
      </div>
      
    </div>
    <button class="button is-medium is-success" @click="submitEditTurnover">Submit</button>
    <button class="button is-medium is-default" @click="cancelEdit">Cancel</button>
  </edit-item>
  <edit-table  id="Turnovers" heading="Turnovers" v-bind:headers="turnoverHeaders" v-bind:total="getTotalCountTurnovers"  v-on:edit="openEditTurnover" v-on:new="openNewTurnover" v-bind:tableData="CleanTurnovers" v-on:reload="fetchRawGameData">
  </edit-table>
  <edit-table id="TOI" heading="Time On Ice" v-bind:headers="toiHeaders" v-bind:total="getTotalCountTOI"  v-bind:tableData="CleanTOI">
  </edit-table>
</div>
</template>
<script>

import EditTable from '../EditTable/edit-table.vue'
import BoxScore from '../EditTable/box-score.vue'
import NewItem from '../EditTable/new-item.vue'
import EditItem from '../EditTable/edit-item.vue'
import EditRoster from '../EditTable/edit-roster.vue'
import _ from 'lodash'
import Notification from 'vue-bulma-notification'
import ShotsHeatmap from './shots-heatmap.vue'
import EditGoalDialog from '../editors/edit-goal-dialog'
import Vue from 'vue'
const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}
export default {
  components: {
    'edit-table': EditTable,
    'box-score': BoxScore,
    'new-item': NewItem,
    'edit-item': EditItem,
    'edit-roster': EditRoster,
    'shots-heatmap': ShotsHeatmap,
    'edit-goal-dialog': EditGoalDialog,
    Notification
  },
  computed: {
    loadEditGoal (goalData) {
      // console.log('Edit Player' + JSON.stringify(goalData))
      this.$refs.EditGoalData.goalData = goalData
      this.$refs.EditGoalData.launch()
      // this.$router.push('/editors/player-edit/' + this.$route.params.teamId + '/' + player.id)
    },
    sortByNumber: function (sort) {
      return sort.slice().sort(function (a, b) {
        return (a.number - b.number)
      })
    },
    getTotalCount () {
      return this.RawData.length
    },
    getTotalCountFaceoff () {
      return this.Test.length
    },
    getTotalCountShots () {
      return this.CleanShots.length
    },
    getTotalCountHits () {
      return this.CleanHits.length
    },
    getTotalCountTurnovers () {
      return this.CleanTurnovers.length
    },
    getTotalCountTOI () {
      return this.CleanTOI.length
    },
    getTotalCountPenaltyMinutes () {
      return this.CleanPenaltyMinutes.length
    },
    getTotalCountGoals () {
      return this.CleanGoals.length
    },
    getTotalCountOddmanRush () {
      // return this.OddmanRush[0].length
    }
  },
  data () {
    return {
      Fixture: [],
      RawData: [],
      faceoffHeaders: [
        'ID', 'Game', 'Time', 'Period', 'Home Player', 'Away Player', 'Lane', 'Zone', 'Result', 'Verified'
      ],
      shotHeaders: [
        'ID', 'Game', 'Time', 'Period', 'Situation', 'Player', 'Type', 'Location', 'Verified'
      ],
      hitHeaders: [
        'ID', 'Game', 'Time', 'Period', 'Situation', 'Player', 'Verified'
      ],
      turnoverHeaders: [
        'ID', 'Game', 'Time', 'Period', 'Situation', 'Player', 'Zone', 'Verified'
      ],
      toiHeaders: [
        'ID', 'Game', 'Time', 'Period', 'Situation', 'Player', 'Shift Length', 'EH', 'SH', 'PP', 'EH +', 'EH -', 'PP +', 'PP -', 'SH +', 'SH -', 'G EH +', 'G EH -', 'G PP +', 'G PP -', 'G SH +', 'G SH -', 'Verified'
      ],
      peanltyMinutesHeaders: [
        'ID', 'Game', 'Time', 'Period', 'Situation Before ', 'Drawn Player', 'Taken Player', 'Infraction', 'Type', 'Length', 'Zone', 'Verified'
      ],
      goalHeaders: [
        'ID', 'Game', 'Time', 'Period', 'Situation', 'GS', 'FA', 'SA', 'Player 1', 'Player 2', 'Player 3', 'Player 4', 'Player 5', 'Player 6', 'Verified'
      ],
      Faceoffs: [],
      Shots: [],
      Hits: [],
      Turnovers: [],
      PenaltyMinutes: [],
      TOI: [],
      OddmanRush: [],
      Goals: [],
      HomePlayerOptions: [],
      AwayPlayerOptions: [],
      AllPlayerOptions: [],
      SituationOptions: [],
      PenaltyOptions: [],
      Test: [],
      CleanShots: [],
      CleanHits: [],
      CleanTurnovers: [],
      CleanTOI: [],
      CleanPenaltyMinutes: [],
      CleanGoals: [],
      newFaceoff: false,
      editFaceoff: false,
      editShot: false,
      editTurnover: false,
      editHit: false,
      editPenaltyMinute: false,
      newPenaltyMinute: false,
      editGoal: false,
      newGoal: false,
      newGoalData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        goal_scorer: 0,
        first_assist: 0,
        second_assist: 0,
        on_ice_1: 0,
        on_ice_2: 0,
        on_ice_3: 0,
        on_ice_4: 0,
        on_ice_5: 0,
        on_ice_6: 0
      },
      editGoalData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        goal_scorer: 0,
        first_assist: 0,
        second_assist: 0,
        on_ice_1: 0,
        on_ice_2: 0,
        on_ice_3: 0,
        on_ice_4: 0,
        on_ice_5: 0,
        on_ice_6: 0
      },
      newPenaltyMinuteData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        drawn_player: 0,
        taken_player: 0,
        penalty_for: 0,
        penlaty_type: 0,
        penlaty_length: 0,
        penalty_zone: ''
      },
      editPenaltyMinuteData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        drawn_player: 0,
        taken_player: 0,
        penalty_for: 0,
        penlaty_type: 0,
        penlaty_length: 0,
        penalty_zone: ''
      },
      newFaceoffData:
      {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: 0,
        result: 0
      },
      editFaceoffData:
      {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: 0,
        result: 0
      },
      newShot: false,
      newShotData:
      {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        shot_type: 0
      },
      editShotData:
      {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        shot_type: 0
      },
      newHit: false,
      newHitData:
      {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0
      },
      editHitData:
      {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0
      },
      newTurnover: false,
      newTurnoverData:
      {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        zone: ''
      },
      editTurnoverData: {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        zone: ''
      },
      ValdiationData: [],
      eihlInfo: []
    }
  },
  methods: {
    validateGame () {
      this.$http.get('https://devilsapi.roblutken.com/api/games/validate/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(res => {
        this.fetchFixtures()
      })
    },
    fetchFixtures () {
      this.$http.get('https://devilsapi.roblutken.com/api/games/get/single/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        // // console.log('Data is ' + response.data)
        this.Fixture = response.data[0]
        console.log(this.Fixture.eihl_id)
        this.$http.get('https://devilsapi.roblutken.com/assets/' + this.Fixture.eihl_id + '_game_info.json', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          this.eihlInfo = response.data
          console.log(this.eihlInfo['1'])
        }, response => {
        })
        // console.log(this.Fixture)
        // // console.log(JSON.stringify(this.Fixture))
      }, response => {
      })
    },
    fetchPlayers () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/get/players/' + this.$route.params.gameId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        let homePlayers = response.data.home_players
        let awayPlayers = response.data.away_players
        homePlayers = homePlayers.slice().sort(function (a, b) {
          return (a.number - b.number)
        })
        awayPlayers = awayPlayers.slice().sort(function (a, b) {
          return (a.number - b.number)
        })
        // // console.log(this.Players)
        // this.playerOptions.push({text: '-', value: -1})
        this.AllPlayerOptions.push({text: 'Home Team', value: -2})
        this.HomePlayerOptions.push({text: 'Home Team', value: -2})
        this.AllPlayerOptions.push({text: 'Forwards', value: -2})
        this.HomePlayerOptions.push({text: 'Forwards', value: -2})
        for (var i of homePlayers) {
          if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
            this.AllPlayerOptions.push({text: '#' + i.number + ' ' + i.surname, value: i.id})
            this.HomePlayerOptions.push({text: '#' + i.number + ' ' + i.surname, value: i.id})
          }
        }
        this.AllPlayerOptions.push({text: 'Defense', value: -2})
        for (var d of homePlayers) {
          if (d.position === 'LD' || d.position === 'RD') {
            this.AllPlayerOptions.push({text: '#' + d.number + ' ' + d.surname, value: d.id})
            this.HomePlayerOptions.push({text: '#' + d.number + ' ' + d.surname, value: d.id})
          }
        }
        this.AllPlayerOptions.push({text: 'Goaltenders', value: -2})
        for (var g of homePlayers) {
          if (g.position === 'GT' || g.position === 'BKGT') {
            this.HomePlayerOptions.push({text: '#' + g.number + ' ' + g.surname, value: g.id})
            this.AllPlayerOptions.push({text: '#' + g.number + ' ' + g.surname, value: g.id})
          }
        }
        this.AllPlayerOptions.push({text: 'Away Team', value: -2})
        this.AwayPlayerOptions.push({text: 'Away Team', value: -2})
        this.AwayPlayerOptions.push({text: 'Forwards', value: -2})
        this.AllPlayerOptions.push({text: 'Forwards', value: -2})
        for (var ai of awayPlayers) {
          if (ai.position === 'LW' || ai.position === 'C' || ai.position === 'RW') {
            this.AllPlayerOptions.push({text: '#' + ai.number + ' ' + ai.surname, value: ai.id})
            this.AwayPlayerOptions.push({text: '#' + ai.number + ' ' + ai.surname, value: ai.id})
          }
        }
        this.AllPlayerOptions.push({text: 'Defense', value: -2})
        for (var ad of awayPlayers) {
          if (ad.position === 'LD' || ad.position === 'RD') {
            this.AllPlayerOptions.push({text: '#' + ad.number + ' ' + ad.surname, value: ad.id})
            this.AwayPlayerOptions.push({text: '#' + ad.number + ' ' + ad.surname, value: ad.id})
          }
        }
        this.AllPlayerOptions.push({text: 'Goaltenders', value: -2})
        for (var ag of awayPlayers) {
          if (ag.position === 'GT' || ag.position === 'BKGT') {
            this.AwayPlayerOptions.push({text: '#' + ag.number + ' ' + ag.surname, value: ag.id})
            this.AllPlayerOptions.push({text: '#' + ag.number + ' ' + ag.surname, value: ag.id})
          }
        }
      }, response => {
      })
    },
    fetchRawGameData () {
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/verify/' + this.$route.params.gameId,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            // console.log('RawData is ' + JSON.stringify(response.data))
            this.RawData = response.data.raw
            this.Faceoffs = response.data.faceoffs
            this.Shots = response.data.shots
            this.Hits = response.data.hits
            this.Turnovers = response.data.turnovers
            this.PenaltyMinutes = response.data.penalty_minutes
            this.OddmanRush = response.data.oddman_rush
            this.Goals = response.data.goals
            let situations = response.data.situations[0]
            // console.log('Situations:' + JSON.stringify(situations))
            for (var k = 0; k < situations.length; k++) {
              this.SituationOptions.push({text: situations[k].secondary_situation, value: situations[k].id})
            }
            if (this.AllPlayerOptions.length <= 0) {
              let homePlayers = response.data.home_players[0]
              let awayPlayers = response.data.away_players[0]
              for (var i = 0; i < homePlayers.length; i++) {
                // this.HomePlayerOptions.push({text: 'Forwards', value: -1})
                // this.AllPlayerOptions.push({text: 'Forwards', value: -1})
                let pos = homePlayers[i].position
                if (pos === 'LW' || pos === 'RW' || pos === 'C') {
                //  this.HomePlayerOptions.push({text: homePlayers[i].number + ' ' + homePlayers[i].surname, value: homePlayers[i].id})
                //  this.AllPlayerOptions.push({text: homePlayers[i].number + ' ' + homePlayers[i].surname, value: homePlayers[i].id})
                }
              }
              for (var j = 0; j < awayPlayers.length; j++) {
              //  this.AwayPlayerOptions.push({text: awayPlayers[j].number + ' ' + awayPlayers[j].surname, value: awayPlayers[j].id})
              //  this.AllPlayerOptions.push({text: awayPlayers[j].number + ' ' + awayPlayers[j].surname, value: awayPlayers[j].id})
              }
            }
            let pimOpt = response.data.penalty_options[0]
            for (var l = 0; l < pimOpt.length; l++) {
              this.PenaltyOptions.push({text: pimOpt[l].option, value: pimOpt[l].id})
            }
            this.TOI = response.data.toi
            this.Test = this.cleanFaceoffData()
            this.CleanShots = this.cleanShotData()
            this.CleanHits = this.cleanHitData()
            this.CleanTurnovers = this.cleanTurnoverData()
            this.CleanTOI = this.cleanTOIData()
            this.CleanPenaltyMinutes = this.cleanPenaltyMinutesData()
            this.CleanGoals = this.cleanGoalData()
          },
          response => {}
        )
    },
    openNewFaceoff () {
      this.newFaceoff = !this.newFaceoff
    },
    openNewShot () {
      this.newShot = !this.newShot
    },
    openNewHit () {
      this.newHit = !this.newHit
    },
    openNewTurnover () {
      this.newTurnover = !this.newTurnover
    },
    openNewPenaltyMinute () {
      this.newPenaltyMinute = !this.newPenaltyMinute
    },
    openNewGoal () {
      this.newGoal = !this.newGoal
    },
    openEditFaceoff (input) {
      this.editFaceoff = !this.editFaceoff
      this.editFaceoffData = this.getFaceoff(input.id)
    },
    openEditShot (input) {
      this.editShot = !this.editShot
      this.editShotData = this.getShot(input.id)
    },
    openEditHit (input) {
      this.editHit = !this.editHit
      // // console.log('Returned: ' + JSON.stringify(input))
      this.editHitData = this.getHit(input.id)
      // // console.log(this.editFaceoffData)
    },
    openEditTurnover (input) {
      this.editTurnover = !this.editTurnover
      // // console.log(JSON.stringify(this.getTurnover(input.id)))
      this.editTurnoverData = this.getTurnover(input.id)
    },
    openEditPenaltyMinutes (input) {
      this.editPenaltyMinute = !this.editPenaltyMinute
      // console.log(JSON.stringify(this.getPenaltyMinutes(input.id)))
      this.editPenaltyMinuteData = this.getPenaltyMinutes(input.id)
    },
    openEditGoal (input) {
      this.editGoal = !this.editGoal
      // console.log(JSON.stringify(this.getGoal(input.id)))
      this.editGoalData = this.getGoal(input.id)
      this.loadEditGoal(this.editGoal)
    },
    submitNewGoal () {
      // console.log(this.newGoalData)
      this.newGoalData.game_id = this.$route.params.gameId
      this.$http.post('https://devilsapi.roblutken.com/api/web/goals/add', this.newGoalData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        this.fetchRawGameData()
      })
      this.newGoal = false
      this.newGoalData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        goal_scorer: 0,
        first_assist: 0,
        second_assist: 0,
        on_ice_1: 0,
        on_ice_2: 0,
        on_ice_3: 0,
        on_ice_4: 0,
        on_ice_5: 0,
        on_ice_6: 0
      }
    },
    submitNewPenaltyMinute () {
      // console.log(this.newPenaltyMinuteData)
      this.newPenaltyMinuteData.game_id = this.$route.params.gameId
      this.$http.post('https://devilsapi.roblutken.com/api/web/penalty-minutes/add', this.newPenaltyMinuteData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        this.fetchRawGameData()
      })
      this.newPenaltyMinute = false
      this.newPenaltyMinuteData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        drawn_player: 0,
        taken_player: 0,
        penalty_for: 0,
        penlaty_type: 0,
        penlaty_length: 0,
        penalty_zone: ''
      }
    },
    submitEditPenaltyMinute () {
      // console.log(this.editPenaltyMinuteData)
      this.editPenaltyMinuteData.game_id = this.$route.params.gameId
      this.$http.post('https://devilsapi.roblutken.com/api/web/penalty-minutes/edit', this.editPenaltyMinuteData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        this.fetchRawGameData()
      })
      this.editPenaltyMinute = false
      this.editPenaltyMinuteData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        drawn_player: 0,
        taken_player: 0,
        penalty_for: 0,
        penlaty_type: 0,
        penlaty_length: 0,
        penalty_zone: ''
      }
    },
    submitEditGoal () {
      // console.log(this.editGoalData)
      this.editGoalData.game_id = this.$route.params.gameId
      this.$http.post('https://devilsapi.roblutken.com/api/web/goals/edit', this.editGoalData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        this.fetchRawGameData()
      })
      this.editGoal = false
      this.editGoalData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        goal_scorer: 0,
        first_assist: 0,
        second_assist: 0,
        on_ice_1: 0,
        on_ice_2: 0,
        on_ice_3: 0,
        on_ice_4: 0,
        on_ice_5: 0,
        on_ice_6: 0
      }
    },
    submitNewFaceoff () {
      // console.log(this.newFaceoffData)
      this.newFaceoffData.game_id = this.$route.params.gameId
      this.$http.post('https://devilsapi.roblutken.com/api/web/faceoffs/add', this.newFaceoffData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
      this.fetchRawGameData()
      this.newFaceoff = false
      this.newFaceoffData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: '',
        result: 0
      }
    },
    submitEditFaceoff () {
      // console.log(this.editFaceoffData)
      this.$http.post('https://devilsapi.roblutken.com/api/web/faceoffs/edit', this.editFaceoffData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Updated Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error updating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
      this.fetchRawGameData()
      this.editFaceoff = false
      this.editFaceoffData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: '',
        result: 0
      }
    },
    submitEditShot () {
      this.$http.post('https://devilsapi.roblutken.com/api/web/shots/edit', this.editShotData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Updated Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error updating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        this.fetchRawGameData()
      })
      this.editShot = false
      this.editShotData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0,
        away_player: 0,
        lane: 0,
        zone: '',
        result: 0
      }
    },
    submitEditHit () {
      this.$http.post('https://devilsapi.roblutken.com/api/web/hits/edit', this.editHitData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        if (response.data.status === 202) {
          openNotification({
            title: 'Updated Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error updating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        this.fetchRawGameData()
      })

      this.editHit = false
      this.editHitData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0
      }
    },
    submitEditTurnover () {
      this.$http.post('https://devilsapi.roblutken.com/api/web/turnovers/edit', this.editTurnoverData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        if (response.data.status === 202) {
          openNotification({
            title: 'Updated Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error updating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
        this.fetchRawGameData()
      })

      this.editTurnover = false
      this.editTurnoverData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        zone: ''
      }
    },
    submitNewShot () {
      // console.log(this.newShotData)
      this.newShotData.game_id = this.$route.params.gameId
      this.$http.post('https://devilsapi.roblutken.com/api/web/shots/add', this.newShotData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
      this.fetchRawGameData()
      this.newShot = false
      this.newShotData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        shot_type: 0
      }
    },
    submitNewHit () {
      // console.log(this.newHitData)
      this.newHitData.game_id = this.$route.params.gameId
      this.$http.post('https://devilsapi.roblutken.com/api/web/hits/add', this.newHitData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
      this.fetchRawGameData()
      this.newHit = false
      this.newHitData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        home_player: 0
      }
    },
    submitNewTurnover () {
      // console.log(this.newTurnoverData)
      this.newTurnoverData.game_id = this.$route.params.gameId
      this.$http.post('https://devilsapi.roblutken.com/api/web/turnovers/add', this.newTurnoverData,
      { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } })
      .then(response => {
        // console.log(response)
        if (response.data.status === 202) {
          openNotification({
            title: 'Created Item',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
        } else {
          openNotification({
            title: 'Error creating this item.',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      })
      this.fetchRawGameData()
      this.newTurnover = false
      this.newTurnoverData = {
        game_id: 0,
        game_time: 0,
        period: '',
        situation_id: 0,
        player_id: 0,
        zone: ''
      }
    },
    cancelNew () {
      this.newFaceoff = false
      this.newShot = false
      this.newHit = false
      this.newTurnover = false
      this.newPenaltyMinute = false
      this.newGoal = false
    },
    cancelEdit () {
      this.editFaceoff = false
      this.editShot = false
      this.editHit = false
      this.editTurnover = false
      this.editPenaltyMinute = false
      this.editGoal = false
    },
    cleanFaceoffData () {
      let cleanData = []
      // // console.log(this.Faceoffs[0])
      _.map(this.Faceoffs[0], function (object) {
        cleanData.push(_.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'home_number', 'away_number', 'lane', 'zone', 'result', 'is_verified']))
      })
      return cleanData
    },
    getFaceoff (id) {
      // console.log('GET FACEOFF RCVD: ' + id)
      return _.find(this.Faceoffs[0], function (obj) { return obj.id === id })
    },
    getShot (id) {
      // console.log('GET Shot RCVD: ' + id)
      // console.log('FOUND: ' + JSON.stringify(_.find(this.Shots[0], function (obj) { return obj.id === id })))
      return _.find(this.Shots[0], function (obj) { return obj.id === id })
    },
    getHit (id) {
      // console.log('GET HIT RCVD: ' + id)
      return _.find(this.Hits[0], function (obj) { return obj.id === id })
    },
    getTurnover (id) {
      // console.log('GET TURNOVER RCVD: ' + id)
      return _.find(this.Turnovers[0], function (obj) { return obj.id === id })
    },
    getPenaltyMinutes  (id) {
      // console.log('GET PIMS RCVD: ' + id)
      return _.find(this.PenaltyMinutes[0], function (obj) { return obj.id === id })
    },
    getGoal (id) {
      // console.log('GET Goal RCVD: ' + id)
      return _.find(this.Goals[0], function (obj) { return obj.goal_id === id })
    },
    cleanShotData () {
      let cleanData = []
      // // console.log(this.Shots[0])
      _.map(this.Shots[0], function (object) {
        cleanData.push(_.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'player_number', 'shot_type', 'shot_location', 'is_verified']))
      })
      return cleanData
    },
    cleanHitData () {
      let cleanData = []
      // // console.log(this.Hits[0])
      _.map(this.Hits[0], function (object) {
        cleanData.push(_.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'home_number', 'is_verified']))
      })
      return cleanData
    },
    cleanTurnoverData () {
      let cleanData = []
      // // console.log(this.Turnovers[0])
      _.map(this.Turnovers[0], function (object) {
        cleanData.push(_.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'player_number', 'zone', 'is_verified']))
      })
      return cleanData
    },
    cleanPenaltyMinutesData () {
      let cleanData = []
      // // console.log(this.TOI[0])
      _.map(this.PenaltyMinutes[0], function (object) {
        cleanData.push(_.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'home_number', 'away_number', 'penalty_for', 'penalty_type', 'penalty_length', 'penalty_zone', 'is_verified']))
      })
      return cleanData
    },
    cleanTOIData () {
      let cleanData = []
      // // console.log(this.TOI[0])
      _.map(this.TOI[0], function (object) {
        cleanData.push(_.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'player_number', 'shift_length', 'eh_time', 'sh_time', 'pp_time', 'eh_chance_for', 'eh_chance_against', 'pp_chance_for', 'pp_chance_against', 'sh_chance_for', 'sh_chance_against', 'goals_for_eh', 'goals_against_eh', 'goals_for_pp', 'goals_against_pp', 'goals_for_sh', 'goals_against_sh', 'is_verified']))
      })
      return cleanData
    },
    cleanGoalData () {
      let cleanData = []
      // // console.log(this.Shots[0])
      _.map(this.Goals[0], function (object) {
        cleanData.push(_.pick(object, ['id', 'game_info', 'game_time_global', 'period', 'situation_name', 'goal_scorer_number', 'first_assist_number', 'second_assist_number', 'on_ice_1_number', 'on_ice_2_number', 'on_ice_3_number', 'on_ice_4_number', 'on_ice_5_number', 'on_ice_6_number', 'is_verified']))
      })
      return cleanData
    },
    openNotificationWithType (type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      }).then(
        this.fetchRawGameData()
      )
    }
  },
  mounted: function () {
    // // console.log('Route loaded with: ' + this.$route.params.gameId)
    this.fetchFixtures()
    this.fetchRawGameData()
    this.fetchPlayers()
  }
}
</script>
<style lang="scss" scoped>
.colourdtd{
  background-color:black;
}
.verified{
  background-color: rgba(0,244,0,.6);
  color:whitesmoke;
}
.unverified{
  background-color: rgba(131, 1, 1, 1);
  color:whitesmoke;
}

.colourdtd:hover{
  background-color:goldenrod;
}
.table__wrapper {
  overflow-x: auto;
}
</style>



// WEBPACK FOOTER //
// match-verifier.vue?7ca2dec2